import { render, staticRenderFns } from "./ActionNotification.vue?vue&type=template&id=444a676a"
import script from "./ActionNotification.vue?vue&type=script&lang=js"
export * from "./ActionNotification.vue?vue&type=script&lang=js"
import style0 from "./ActionNotification.vue?vue&type=style&index=0&id=444a676a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports